module.exports = __webpack_public_path__ + "images/team-empty@2x-85247ee7f09496dd2e76633f200de0cc.png";